export default {
    correct_answers: "Correct answers",
    drag_and_drop: "Drag and drop",
    drag_the_words_description: "The player must choose the available words and drag them to the word field in the text, until all available words are used.",
    drag_the_words_failure_message: "Too bad, you didn't make it. Try again!",
    drag_the_words_instructions: "You will a see text with blank spaces and a field with words to choose from. You must drag the words into the blanks until there are no words left in your options.",
    drag_the_words_success_message: "Congratulations, you got all the words correctly and completed the game!",
    drag_the_words: "Drag the words",
    enigma_failure_message: "Too bad you didn't make it. Try again.",
    enigma_instructions: "See the tips and solve the riddles!",
    enigma_success_message: "Congratulations, you managed to follow the clues correctly and solved the riddle!",
    enigma: "Riddle",
    errors: "Errors",
    example: "Example",
    fill_in_the_blanks_failure_message: "Too bad, you didn't make it. Try again!",
    fill_in_the_blanks_instructions: "The player must fill in the blanks. When filling all the blank spaces, the player must click on submit for the game to end.",
    fill_in_the_blanks_success_message: "Congratulations, you got all the words correctly and completed the game!",
    fill_in_the_blanks: "Fill in the blanks",
    find_the_pairs_failure_message: "What a pity, you exceeded the limit of errors allowed. Try again.",
    find_the_pairs_instructions: "The player will have two columns and must click on one of the options in one column, then click on one of the options in the column to the side. The game will end when all options are selected.",
    find_the_pairs_success_message: "Congratulations, you managed to find the pairs correctly!",
    find_the_pairs: "Find The Pairs",
    flashcards_failure_message: "Too bad you didn't make it. Try again.",
    flashcards_instructions: "The player must add an answer to each flashcard, until he completes the game.",
    flashcards_success_message: "Congratulations, you got all the flashcards right!",
    flashcards: "Flashcards",
    forfeit: "Give up",
    game_type: "Game type",
    games: "Games",
    infinite: "Infinite",
    instructions: "Instructions",
    play_again: "Play again",
    play: "Play",
    qty_errors_allowed: "Number of errors allowed",
    restart: "Restart",
    result: "Result",
    that: "That",
    this_or_blanks_success_message: "Congratulations, you got This or That right!",
    this_or_that_failure_message: "Too bad you didn't make it. Try again.",
    this_or_that_instructions: "The player will see a description and must choose the option 'this' or 'that', until they tick all available options.",
    this_or_that: "This or That",
    this: "This",
    tip: "Tip",
    true_or_false_failure_message: "Too bad you didn't make it. Try again.",
    true_or_false_instructions: "Choose the true or false option for each of the sentences.",
    true_or_false_success_message: "Congratulations, you got True or False right!",
    true_or_false: "True or False",
    words: "Words"
}